import { esc, q } from '../../shared/dom';
import { t } from '../../shared/i18n';
import { ApiError } from '../../shared/api/http';
import { login } from '../../shared/session/session';
import { bindPasswordToggles, passwordField } from './password-field';
import { authRoutes } from './auth-routes';

/** Tela de login: e-mail + senha. Quem entra é levado ao painel do seu papel. */
export function renderLoginScreen(root: HTMLElement): void {
  root.innerHTML = `
    <h2 class="auth-title" data-i18n="auth.loginTitle">${esc(t('auth.loginTitle'))}</h2>
    <p class="auth-lead" data-i18n="auth.loginLead">${esc(t('auth.loginLead'))}</p>
    <form class="auth-form" id="login-form" novalidate>
      <div class="auth-field">
        <label for="login-email" data-i18n="auth.email">${esc(t('auth.email'))}</label>
        <input type="email" id="login-email" autocomplete="username" inputmode="email" placeholder="nombre@apuesterapido.com" required autofocus>
      </div>
      ${passwordField('login-password', 'auth.password', { autocomplete: 'current-password' })}
      <div class="auth-error" id="login-error" role="alert"></div>
      <button type="submit" class="btn btn-primary auth-submit" id="login-submit">${esc(t('auth.enter'))}</button>
      <div class="auth-links">
        <span></span>
        <a class="auth-link" href="${authRoutes.forgot}" data-i18n="auth.forgotLink">${esc(t('auth.forgotLink'))}</a>
      </div>
    </form>`;

  bindPasswordToggles(root);
  const form = q<HTMLFormElement>('#login-form', root);
  const email = q<HTMLInputElement>('#login-email', root);
  const password = q<HTMLInputElement>('#login-password', root);
  const error = q('#login-error', root);
  const submit = q<HTMLButtonElement>('#login-submit', root);

  form.addEventListener('submit', async e => {
    e.preventDefault();
    error.textContent = '';
    email.setAttribute('aria-invalid', 'false');
    const mail = email.value.trim();
    if (!mail || !mail.includes('@')) { email.setAttribute('aria-invalid', 'true'); error.textContent = t('auth.errEmail'); email.focus(); return; }
    if (!password.value) { error.textContent = t('auth.errPassword'); password.focus(); return; }

    submit.disabled = true; submit.textContent = t('auth.entering');
    try {
      await login(mail, password.value);   // o shell escuta 'session' e leva ao painel certo
    } catch (err) {
      error.textContent = err instanceof ApiError ? friendlyLoginError(err) : t('auth.errGeneric');
      password.select();
    } finally {
      submit.disabled = false; submit.textContent = t('auth.enter');
    }
  });
}

function friendlyLoginError(err: ApiError): string {
  if (err.status === 401) return t('auth.errCredentials');
  if (err.status === 429) return t('auth.errTooMany');
  if (err.status === 0)   return t('auth.errOffline');
  return err.message;
}
